import { elakay_API } from "../../config";
import { isAuthenticated } from "../auth";

const token = () => isAuthenticated()?.token || "";

const request = async (path, { method = "GET", body } = {}) => {
  const headers = { Accept: "application/json" };
  const currentToken = token();
  if (currentToken) headers.Authorization = `Bearer ${currentToken}`;
  const options = { method, headers };
  if (body !== undefined) {
    headers["Content-Type"] = "application/json";
    options.body = JSON.stringify(body);
  }
  const response = await fetch(`${elakay_API}${path}`, options);
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || `Erreur ${response.status}`);
    error.status = response.status;
    error.code = data.code;
    error.details = data.details;
    throw error;
  }
  return data;
};

const queryString = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") query.set(key, String(value));
  });
  const value = query.toString();
  return value ? `?${value}` : "";
};

export const listMediaAssets = (params) => request(`/media-library${queryString(params)}`);
export const findDuplicateMediaAsset = (params) => request(`/media-library/duplicate${queryString(params)}`);
export const createMediaAsset = (payload) => request("/media-library", { method: "POST", body: payload });
export const updateMediaAsset = (id, payload) => request(`/media-library/${id}`, { method: "PATCH", body: payload });
export const getMediaAssetUsages = (id) => request(`/media-library/${id}/usages`);
export const archiveMediaAsset = (id, force = false) => request(`/media-library/${id}/archive${force ? "?force=1" : ""}`, { method: "POST" });
export const restoreMediaAsset = (id) => request(`/media-library/${id}/restore`, { method: "POST" });

